import { Component,
         Output,
         EventEmitter }               from '@angular/core';
import { TableColumn,
         TableColumnType }            from './../common/table-column';
import { TrainService }               from './../shared/train.service';
import { PeakService }                from './../shared/peak.service';
import { Observable }                 from 'rxjs/Observable';
import { ISortableFilter,
         SortableFilter }             from './../common/sortable-filter';
import { PeakSortableFilter }         from './peak-sortable-filter';
import { PeakDialogComponent }        from './../peak-dialog/peak-dialog.component';
import { PeakCopyDialogComponent }    from './../peak-copy-dialog/peak-copy-dialog.component';
import { PeakImportDialogComponent }  from './../peak-import-dialog/peak-import-dialog.component';
import { MatDialog }                   from '@angular/material';
import { Globals }                    from './../common/globals';
import { SavingDialogComponent }      from './../common/saving-dialog.component';
import { LoadingDialogComponent } from '../common/loading-dialog.component';


@Component({
  selector: 'sa-peak-list',
  template: require('./peak-list.component.html'),
  styles: [require('./peak-list.component.scss')]
})
export class PeakListComponent {

  @Output() filter = new PeakSortableFilter('Date');
  @Output() performSearch = new EventEmitter();
  @Output() columns: Array<TableColumn>;
  @Output() service: PeakService;

  public getDataCallback: Function;
  trainFilter: ISortableFilter = new SortableFilter('trainName');

  private trains: any[];
  private peakValues: Array<any>;
  private trainsReady = false;
  private filterReady = false;

  private availableYears = () => { return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((_, idx) => (new Date().getFullYear() - 3 + (idx + 1))); };
  private availableMonts = () => { return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; };

  constructor(
    trainService: TrainService,
    peakService: PeakService,
    public dialog: MatDialog,
    public globals: Globals
  ) {
     this.getDataCallback = this.getData.bind(this);
     this.service = peakService;

    let cloakRef = this.dialog.open(LoadingDialogComponent);
    trainService.getNames(this.trainFilter)
      .subscribe(t => {
        this.trains = t;
        this.trainsReady = true;
        cloakRef.close();
      });

    peakService.getPeakValues()
      .subscribe(p => {
        this.peakValues = p;
      });

    this.columns = [
      new TableColumn(TableColumnType.DayOfMonth, 'date', 'Den', 60),
      new TableColumn(TableColumnType.Text, 'peakName', 'Úroveň špičky', 250)
    ];

    this.filter.year = (new Date).getFullYear();
    this.filter.month = (new Date).getMonth() + 1;
  }

  private getData(filter: PeakSortableFilter) {
    if (!!filter.trainUid) {
      return this.service.getItems(filter);
    }
    return Observable.from(Array<any>());
  }

  filterChanged(event) {
    if (this.filter.month != null && this.filter.year != null && this.filter.trainUid != null) {
      this.filterReady = true;
      this.performSearch.emit(this.filter);
    }
  }

  copy() {
    let dialogRef = this.dialog.open(PeakCopyDialogComponent);
    dialogRef.componentInstance.model = this.filter;
    dialogRef.componentInstance.trains = this.trains;
    dialogRef.componentInstance.months = this.availableMonts();
    dialogRef.componentInstance.years = this.availableYears();
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.service.copy(this.filter, dialogRef.componentInstance.targetModel)
          .subscribe(res => {
            cloakRef.close();
            console.log('Peak updated');
            this.performSearch.emit(this.filter);
          });
      }
    });
  }

  import() {
    let dialogRef = this.dialog.open(PeakImportDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (!!this.filter.month && !!this.filter.trainUid && this.filter.year !== null) {
        this.performSearch.emit(this.filter);
      }
    });
  }

  editItem(model) {
    let dialogRef = this.dialog.open(PeakDialogComponent);
    dialogRef.componentInstance.model = model;
    let train = this.trains.filter((t, i) => t.trainUid === model.trainUid)[0];
    dialogRef.componentInstance.model.trainName = train.trainName;
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        this.service.insertItem(dialogRef.componentInstance.model)
          .subscribe(res => {
            console.log('Peak updated');
            this.performSearch.emit(this.filter);
          });
      } else if (result === 'delete') {
        dialogRef.componentInstance.model.peakID = -1;
        this.service.insertItem(dialogRef.componentInstance.model)
          .subscribe(res => {
            console.log('Peak updated');
            this.performSearch.emit(this.filter);
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/peak-list/peak-list.component.ts